import styled from "@emotion/styled";
import { baseFormLabelClasses } from "@kaltura/mediaspace-shared-ui";
import { FormLabel } from "@kaltura/mediaspace-shared-ui/form";
import { ModalActions, Typography } from "@kaltura/ds-react-components";

export const StyledContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
}));

export const StyledCheckboxWrap = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1),
}));
export const StyledCheckboxLabel = styled(FormLabel)({
    [`& .${baseFormLabelClasses.label}.${baseFormLabelClasses.label}`]: {
        paddingBottom: 0,
    },
});

export const StyledModalActions = styled(ModalActions)({
    justifyContent: "space-between",
});

export const StyledButtonsContainer = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
}));

export const StyledModalText = styled(
    Typography,
    { shouldForwardProp: (propName) => propName !== "withUserSelection" }
)<{ withUserSelection?: boolean }>(({ withUserSelection }) => ({
    ...(!withUserSelection && { textAlign: "center" }),
}));
